export default __webpack_public_path__ + "static/media/LocationPin.cc5d3a62.svg";